export default __webpack_public_path__ + "static/single-step-light-29b84d2e775b7b240ef7ff052a055459e59d903006bd291b7abf263349646372.png";